var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"loading":_vm.loading,"outlined":""}},[_c('ListTitle',{attrs:{"access":false,"title":"Stock","showBackButton":false}}),_c('div',{attrs:{"id":"stock-line"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }